import freeDomains from './freeDomains';

interface FilterFreeDomains {
  shouldRestrictDomain: boolean;
  currentDomain: string;
}

const filterFreeDomains = (input: string): FilterFreeDomains => {
  const currentDomain = input.substring(input.indexOf('@'));
  return {
    shouldRestrictDomain: freeDomains.includes(currentDomain),
    currentDomain
  };
};

export default filterFreeDomains;
